import { CookieBanner } from "./cookie-banner";
import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-cookie-consent' })
export class CookieConsentComponent {
	constructor(private element: HTMLElement) {
		const connectionIsSecure = element.hasAttribute('data-cookie-secure')
			? element.getAttribute('data-cookie-secure').toLowerCase() ===
			'true'
			: true;
		new CookieBanner([], {
			showAfter: 600,
			cookie: {
				expirationInDays: 365,
				secure: connectionIsSecure
			}
		});
	}
}
